import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { ImageService } from '../../../../services/image.service';

@Component({
    selector: 'ig-block-navigator',
    templateUrl: './block.navigator.component.html',
    styleUrls: ['./block.navigator.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BlockNavigatorComponent extends BaseComponent implements OnInit {
    @Input() public items: any[];
    public hubName: string;
    public selected: any;
    public isNeedScroll = true;
    public stepPx = 40;
    //public stepPX = isFirefox() ? 20 : 10;

    @ViewChild('wrap') public wrap: ElementRef;
    @Output() onCityClick = new EventEmitter<any>();

    constructor(private router: Router,
                public imageService: ImageService,
                private activatedRoute: ActivatedRoute) {
        super({activatedRoute});
    }

    public ngOnInit() {
        let {hubName} = this.allRouteParams;
        this.hubName = hubName;

        this.getIsNeedScroll();
    }

    public cityClick(city) {
        this.selected = city;
        this.onCityClick.emit(city);
        this.getIsNeedScroll();
    }

    public setSelectedCity(value) {
        this.selected = value;
    }

    public setSelectedCityById(id) {
        if (this.items && this.items.length) {
            let city = this.items.first(x => x.id === id);
            if (city) {
                this.selected = city;
            }
        }
    }

    public scrollToCity(id) {
        if (this.items && this.items.length) {
            let index = this.items.getElementIndex(x => x.id === id);
            if (index >= 0) {
                this.wrap.nativeElement.scrollLeft = 186 * index;
            }
        }
    }

    public goLeft() {
        let width = this.wrap.nativeElement.clientWidth;
        let x = 0;
        let interval = setInterval(() => {
            this.wrap.nativeElement.scrollBy(this.stepPx * -1, 0);
            x = x + this.stepPx;
            if (x >= width - 170) {
                clearInterval(interval);
            }
        }, 5);
    }

    public goRight() {
        let width = this.wrap.nativeElement.clientWidth;
        let x = 0;
        let interval = setInterval(() => {
            this.wrap.nativeElement.scrollBy(this.stepPx, 0);
            x = x + this.stepPx;
            if (x >= width - 170) {
                clearInterval(interval);
            }
        }, 5);
    }

    public scrollToStart() {
        if (this.wrap) {
            this.wrap.nativeElement.scroll(0, 0);
        }
    }

    public getIsNeedScroll() {

        setTimeout(() => {
            if (this.wrap) {
                let scrollWidth = this.wrap.nativeElement.scrollWidth;
                let clientWidth = this.wrap.nativeElement.clientWidth;
                console.log(`scrollWidth: ${scrollWidth}, clientWidth: ${clientWidth}`);

                this.isNeedScroll = scrollWidth > clientWidth;
            }
        });
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/block.navigator/block.navigator.component.ts